<template>
  <label class="big-radio-button-label uk-display-block uk-text-center">
    <input
      type="radio"
      :name="name"
      class="big-radio-button uk-radio"
      :class={active}
      :value="label.toLowerCase()"
      v-model="radioButtonValue"
    /><br>
    {{label}}
  </label>
</template>

<script>
export default {
  name: 'BigRadioButton.vue',
  props: {
    label: String,
    name: String,
    index: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    radioButtonValue: {
      get() {
        return this.value;
      },
      set() {
        this.$emit('change', this.index ?? this.label.toLowerCase());
      },
    },
  },
};
</script>
